import { hrDateWithTime } from "@king-ict/eupisi-ui/utils";

import i18n from "../../../app/i18n";
import {
  EnrollmentDecision,
  OutsideEnrollmentAreaStatus,
  Request,
} from "../../../models/Request";
import { isStatusOutsideEnrollmentAreaDecision } from "../../../utils";

export const formatDateTimeWithUser = (
  date: Date | null | undefined,
  user?: { firstName?: string; lastName?: string }
) => {
  if (!date) return "";
  const { firstName, lastName } = user || {};

  const dateTime = hrDateWithTime(date);
  if (!firstName || !lastName) return dateTime;

  return `${dateTime}, ${firstName} ${lastName}`;
};

export const generateApprovalText = (
  item: Request,
  enrollmentDecision?: EnrollmentDecision
) => {
  if (enrollmentDecision?.solutionId !== undefined) {
    return i18n.t(
      "suggestedOutsideEnrollmentArea.approvedByEnrollmentDecision"
    );
  }

  const isApproved =
    isStatusOutsideEnrollmentAreaDecision(item.outsideEnrollmentAreaStatus) &&
    item.approvedEnrollmentOutsideEnrollmentArea;

  return i18n.t(isApproved ? "common.yes" : "common.no");
};

export const generateSecondaryInstitutionApprovedText = (
  item: Request,
  enrollmentDecision: EnrollmentDecision | undefined
) => {
  if (enrollmentDecision?.solutionId !== undefined) {
    return i18n.t(
      "suggestedOutsideEnrollmentArea.approvedByEnrollmentDecision"
    );
  }

  switch (item.outsideEnrollmentAreaStatus) {
    case OutsideEnrollmentAreaStatus.SuggestedEnrollmentAccepted:
      return i18n.t("outsideEnrollmentAreaStatus.SuggestedEnrollmentAccepted");
    case OutsideEnrollmentAreaStatus.SuggestedEnrollmentRejected:
      return i18n.t("outsideEnrollmentAreaStatus.SuggestedEnrollmentRejected");
    case OutsideEnrollmentAreaStatus.DecisionAccepted:
    case OutsideEnrollmentAreaStatus.DecisionDeclined:
      const isApproved = item.suggestedEnrollmentOutsideEnrollmentArea;
      return i18n.t(isApproved ? "common.yes" : "common.no");
    default:
      return i18n.t("outsideEnrollmentAreaStatus.NotProcessed");
  }
};

export const getVisibilityState = (
  isEditing: boolean,
  canSaveRequest: boolean | undefined,
  canEdit: boolean
): "show" | "hide" | "disable" => {
  if (!canEdit) {
    return "hide";
  }

  if (isEditing) {
    return "hide";
  }

  if (canSaveRequest) {
    return "show";
  }

  return "disable";
};
